import CloseIcon from "@mui/icons-material/Close";
import { Box, CSSObject, styled, Theme } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { PlatXLogo } from "@platformx/shared/static-assets";
import { MiniHeader, navigateBasedRole } from "@platformx/utilities";
import { useNavigate } from "react-router-dom";
import LeftSideBarStyle from "./LeftSidebar.styles";
import MenuList from "./MenuList";

const DrawerWidth = 250;
const openedMixin = (theme: Theme): CSSObject => ({
  width: DrawerWidth,
  [theme.breakpoints.down("sm")]: {
    width: "0px",
  },
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: DrawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .Platform-x-Drawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .Platform-x-Drawer-paper": closedMixin(theme),
  }),
}));

export default function LeftSideBar({ open, handleDrawerOpen, handleMenuAction, className }) {
  const classes = LeftSideBarStyle();
  const navigate = useNavigate();
  return (
    <Box className={`${className} ${classes.mainSideBar}`}>
      <Drawer variant='permanent' open={open}>
        <Box className='LeftSidebarMain'>
          <Box>
            <Box className='logoContainer'>
              <img
                src={PlatXLogo}
                alt='logo'
                className='logo'
                //onClick={() => navigate("/dashboard")}
                onClick={() => navigateBasedRole(navigate)}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    navigateBasedRole(navigate);
                  }
                }}
                role='button'
                data-testid='navigate-based-role'
              />

              <Box
                className='closeIcon'
                role='button'
                tabIndex={0}
                onClick={handleDrawerOpen}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleDrawerOpen();
                  }
                }}
                data-testid='close-drawer'>
                <CloseIcon />
              </Box>
            </Box>
            <MenuList
              open={open}
              handleMenuclose={handleDrawerOpen}
              handleMenuAction={handleMenuAction}
            />
          </Box>
          <Box className='auth'>
            <MiniHeader />
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
